import { FormProvider, useForm } from 'react-hook-form';
import type { WithChildrenProps } from '../../types/components/common';

export const InitializedFormProvider = ({ children }: WithChildrenProps) => {
  const formMethods = useForm();

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
